export default __webpack_public_path__ + "static/media/zawodnik9.a83d7988.png";